import * as types from 'store/mutation-types'
import { MARKET_NAME, MARKET_TYPE, SEC_TYPE } from 'const/stock'
import isSameStock from 'utils/isSameStock'
import getLocalFixedQuoteDetail from 'utils/getLocalFixedQuoteDetail'

const state = {
  list: [],
  group: '0', // 默认全部
  filterMarket: MARKET_NAME.ALL, // 默认全部
  notify: ''
}

const mutations = {
  [types.DELETE_FROM_WATCHLIST](state, stockList) {
    stockList.map(listItem => {
      const index = state.list.findIndex(
        stock => stock.webLocal.symbol === listItem.symbol
      )
      if (index >= 0) {
        state.list.splice(index, 1)
      }
    })
  },
  [types.INIT_WATCHLIST](state, payload) {
    state.list = payload.stocks
  },
  [types.UPDATE_WATCHLIST_DISPLAY](state, list) {
    state.list = list
  },
  [types.UPDATE_WATCHLIST](state, list) {
    list.forEach(stock => {
      const existedStock = state.list.find(iterStock =>
        isSameStock(iterStock, stock)
      )
      if (existedStock) {
        if (!stock.source === 'mqtt') {
          delete existedStock.hourTrading
        }
        Object.assign(existedStock, stock)
        if (
          existedStock.futContent &&
          existedStock.futContent.securityType === SEC_TYPE.FUT
        ) {
          const multiOffset =
            existedStock.futContent.productPriceConfig.displayMultiplier.offset
          const multiVal =
            existedStock.futContent.productPriceConfig.displayMultiplier.value
          const multiplier = multiVal * Math.pow(10, `-${multiOffset}`)
          const times =
            Math.pow(10, `-${existedStock.futContent.priceOffset}`) * multiplier
          existedStock.latestPrice = existedStock.latestPrice * times
          existedStock.preClose = existedStock.preClose * times
          existedStock.change = existedStock.latestPrice - existedStock.preClose
          if (!stock.preClose) stock.changeRate = 0
          else stock.changeRate = stock.change / stock.preClose
        }
      }
    })
  },
  [types.CLEAR_WATCHLIST](state) {
    state.list = []
  },
  [types.ADD_WATCHLIST_NOTIFY](state, message) {
    state.notify = message
  },
  [types.REMOVE_WATCHLIST_NOTIFY](state) {
    state.notify = ''
  },
  [types.UPDATE_WATCHLIST_GROUP](state, group) {
    state.group = group
  },
  [types.UPDATE_WATCHLIST_MARKET](state, market) {
    state.filterMarket = market
  }
}

const getters = {
  watchListAll(state) {
    return getLocalFixedQuoteDetail(state.list)
  },
  watchListOfUS(state, getters) {
    return getters.watchListAll.filter(
      stock => stock.market === MARKET_TYPE.US && stock.secType !== SEC_TYPE.OPT
    )
  },
  watchListOfHK(state, getters) {
    return getters.watchListAll.filter(stock => stock.market === MARKET_TYPE.HK)
  },
  watchListOfUK(state, getters) {
    return getters.watchListAll.filter(stock => stock.market === MARKET_TYPE.UK)
  },
  watchListOfA(state, getters) {
    return getters.watchListAll.filter(stock =>
      MARKET_TYPE.A.includes(stock.market)
    )
  },
  watchListOPT(state, getters) {
    return getters.watchListAll.filter(stock => stock.secType === SEC_TYPE.OPT)
  },
  watchListFUT(state, getters) {
    return getters.watchListAll.filter(
      stock =>
        stock.futContent && stock.futContent.securityType === SEC_TYPE.FUT
    )
  },
  curWatchGroup(state) {
    return state.group
  },
  curWatchMarket(state) {
    return state.filterMarket
  },
  allHKStocks(state) {
    return state.list.filter(stock => stock.market === MARKET_TYPE.HK)
  },
  hkDelay(state, getters) {
    return !getters.hasHkLv2Permission && getters.allHKStocks.length > 20
  },
  ukDelay(state, getters) {
    return !getters.hasUkLv1Permission
  }
}

export default { state, mutations, getters }
